/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OrganizationsControllerFindAllQueryResponse, OrganizationsControllerFindAllQueryParams, OrganizationsControllerFindAll401, OrganizationsControllerFindAll403 } from "../../models/organizationsController/OrganizationsControllerFindAll";

function getOrganizationsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/organizations` as const }  
  return res
}

/**
 * @summary Get all organizations for the current user
 * {@link /api/v1/organizations}
 */
export async function organizationsControllerFindAll(params?: OrganizationsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<OrganizationsControllerFindAllQueryResponse, ResponseErrorConfig<OrganizationsControllerFindAll401 | OrganizationsControllerFindAll403>, unknown>({ method : "GET", url : getOrganizationsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}